module.exports = __webpack_public_path__ + "img/code.d28eb486.png";